import React, { useState } from 'react';
import './ShippingSolution.css'
import cycle from '../../images/deliver-cycle.jpg'
import about from '../../images/about.png'
import AOS from 'aos';
import 'aos/dist/aos.css';


AOS.init();

const ShippingSolution = () => {
    const [solution,setSolution]=useState([])
    return (
        <div className='py-5'>
            <h1>We Are Shipping Solution</h1>
            <p className='mb-4'>Ship locally or globally to your customers with our reliable solutions.Whether you're an entrepreneur or enterprise</p>

            <div className="container">
                <div className="row">
                    <div className="col-md-5">
                        <div>
                            <div class="row border-bottom row-cols-1 row-cols-md-2 g-4">
                            <div class="col">
                                <div class="card-body col d-flex align-items-center justify-content-center">
                                    <span><i class="far fa-newspaper"></i></span>
                                    <h6 class="card-title">License Agreement</h6>
                                </div>
                            </div>
                            <div class="col align-items-center justify-content-center">
                                <div class="card-body col d-flex">
                                    <span><i class="far fa-flag"></i></span>
                                    <h6 class="card-title">Goods Insurance</h6>
                                </div>
                            </div>

                            <div class="card-body align-items-center justify-content-center col d-flex">
                                <span><i class="fas fa-map-pin"></i></span>
                                <h6 class="card-title">Service Location</h6>
                            </div>
                            <div class="card-body col align-items-center justify-content-center d-flex">
                                <span><i class="far fa-calendar-alt"></i></span>
                                <h6 class="card-title">Estimated Time</h6>
                            </div>
                            
                            </div>
                            <div className='mt-4'>
                                <img style={{borderRadius:'10px'}} className='w-75 h-50' src={cycle} alt="" />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-7">
                        <img data-aos="fade-left" className='img-fluid' src={about} alt="" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ShippingSolution;